// extracted by mini-css-extract-plugin
export var columnList = "_cu-0";